// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".6117db57d577f581a1ca8146a22a5144c29d07a0.chunk.bundle.js";
};